import { type IExternalWagerService, type IUpdateExternalWagerUseCase } from '../../../domain/entry.js';

/**
 * Use case for updating an external wager by setting 'paid' attribute to true.
 *
 * @param externalWagerService External wager service dependency
 * @returns Use case executor for updating an external wager
 */
export function updateExternalWagerUseCase(externalWagerService: IExternalWagerService): IUpdateExternalWagerUseCase {
  return {
    execute: async ({ externalWagerGuid, transactionIds }): ReturnType<IUpdateExternalWagerUseCase['execute']> => {
      await externalWagerService.updateExternalWagerAsync(externalWagerGuid, transactionIds);
      return undefined;
    },
  };
}
